import React from 'react';
import * as Styles from '../styles';
import { Link } from '../../../../Link';
import { sendClickEvent } from '../../../utils/sendClickEvent';
export const contentLinks = TabLinks => {
  return React.createElement(React.Fragment, null, TabLinks.links.map((columns, index) => React.createElement(Styles.TabColumn, {
    className: "ds-tab-column",
    key: index
  }, columns.map((link, subIndex) => React.createElement(Link, {
    className: "ds-footer-link",
    href: link.href,
    variant: "grey",
    key: subIndex,
    onClick: () => sendClickEvent('links_tabs', 'footer', {
      page_destination: link.href
    }),
    size: "medium",
    "data-ds-component": "DS-Footer-Link"
  }, link.label)))));
};